import { Component } from 'react';
import axios from 'axios';
import Header from '../Header';
import { Accordion, Card } from "react-bootstrap";
import parse from 'html-react-parser';
import LoadingScreen from '../common/loading-screen';
import TableHeaderBenefits from '../common/table-header';

import { HEARTIST_BENEFITS, HEARTIST_EMAIL_CHECK } from '../../constants/index';
import { validEmail, getUrl, validFromOctober2025 } from '../helper';

import '../../css/style.css';

class Home extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: "",
            errorMessage: "",
            isValidEmail: true,
            isLoading: false
        }

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleInputChange = (e) => {
        this.setState({
            email: e.target.value,
            isValidEmail: true,
            errorMessage: ""
        });
    };

    handleSubmit = async () => {
        const { email } = this.state;

        this.setState({ isLoading: true });

        if (!email) return this.setError("Email address is required.");
        if (!validEmail(email)) return this.setError("Email address not valid.");

        try {
            const response = await axios.post(HEARTIST_EMAIL_CHECK, { email: email });
            const { status, data } = response;

            if (status === 200) {
                if (data.coupon_code) {
                    const { urlRoot } = getUrl();
                    const redirectUrl = `${urlRoot}partner/heartist/?couponCode=${data.coupon_code}`;
                    console.log("URL", redirectUrl);

                    window.location.href = redirectUrl;
                } else {
                    this.setError("ErrorCode (1048): This coupon code has been used. Please contact our <a href='https://help.accorplus.com/hc/en-au'>Member Services</a> team if you need assistance.");
                }
            }

            this.setState({ isLoading: false });
        } catch (err) {
            const status = err?.response?.status;
            const message = this.mapErrorMessage(status, err);
            console.log(err);

            this.setState({
                isValidEmail: false,
                errorMessage: message,
                isLoading: false
            });
        }
    };

    setError(message) {
        this.setState({
            isLoading: false,
            isValidEmail: false,
            errorMessage: message
        });
    }

    mapErrorMessage(status, err) {
        switch (status) {
            case 400:
                return `We can't seem to proceed…<br/>Our record shows that the email address provided is not valid.`;
            case 401:
                return `We can't seem to proceed…<br/>Please contact our Member Services team at <a href='mailto:members.singapore@accorplus.com' target='_blank'>members.singapore@accorplus.com</a> for further assistance.`;
            case 402:
                return `We can't seem to proceed…<br/>Our record shows that you have registered for your complimentary ALL Accor+ Explorer membership. If you require further assistance, please contact our Member Services team at <a href='mailto:members.singapore@accorplus.com' target='_blank'>members.singapore@accorplus.com</a>`;
            default:
                return (
                    err?.response?.data?.error ||
                    "Something went wrong. Please try again later."
                );
        }
    }

    render() {
        const { errorMessage, isValidEmail, isLoading } = this.state;
        let new_benefits;

        if (HEARTIST_BENEFITS) {
            new_benefits = HEARTIST_BENEFITS.map((item, index) =>
                <Card key={index} className="benefits">
                    <Accordion.Toggle as={Card.Header} eventKey={index + 1}>
                        <div className="row d-flex ">
                            <div className="mb-0 col-10 col-md-11 accordion-title-text">
                                {item.title}
                            </div>
                            <div className="mb-0 col-2 col-md-1">
                                <img alt="plus-symbol" src="/images/plus-symbol.png" width="22" />
                            </div>
                        </div>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey={index + 1}>
                        <Card.Body>
                            <div className="row">
                                <div className="col-12">
                                    {parse(item.description)}
                                </div>
                            </div>
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>
            );
        };

        var errrorClass = "";
        if (!isValidEmail) {
            errrorClass = "validation-error"
        }

        return (
            <div class="hotelSales-wrapper">
                <Header
                    handleLeaderBoard={this.handleLeaderBoard}
                    bannerClass="banner-heartist"
                    bannerText={`Discover a Travel Membership Designed for <br/>Explorers at Heart`}
                />

                <div className="container">
                    <div class="mt-5 container">
                        <h2>Are You an Explorer?</h2>
                        <p>Designed for travellers and explorers at theart, All Accor+ Explorer unlocks exclusive hotel deals, dining offers, and unforgettable travel experience. Enjoy Stay Plus FREE Nights up to 50% off Red Hot Rooms, incredible dining savings, and instant ALL Accor Elite status. Join today and discover how rewarding your journeys can be.</p>
                    </div>

                    <TableHeaderBenefits tableTitle={validFromOctober2025("ALL ACCOR+ EXPLORER BENEFITS")} />

                    <div className="container accordion-container mt-3 benefits-container mb-5">
                        <Accordion defaultActiveKey="0">
                            {new_benefits}
                        </Accordion>
                    </div>

                    <div className="container">
                        <h5 class="px-0 py-3">Enter your email address to start experiencing more!</h5>

                        <div class="py-3">
                            {!isValidEmail && (<div class="mb-4 text-bold text-center">{parse(errorMessage)}</div>)}

                            <input
                                type="text"
                                class={`email-check-input ${errrorClass}`}
                                placeholder="Enter email"
                                onChange={this.handleInputChange}
                            />

                            <button
                                class="email-check-input-submit btn btn-primary mt-2 button theme-primary"
                                onClick={this.handleSubmit}
                            >
                                Submit
                                <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    xmlns="http://www.w3.org/2000/svg"
                                    class="icon"
                                >
                                    <path d="M17.42 10l-6.951-6.95-1.326 1.325 4.687 4.688H2.97v1.874H13.83l-4.687 4.688 1.326 1.326L17.419 10z"></path>
                                </svg>
                            </button>

                            {isLoading && (<LoadingScreen/>)}
                        </div>
                    </div>

                    <div class="container terms_conditions mt-4">
                        <p class="title"><strong>Terms and conditions:</strong></p>

                        <p>- All ALL Accor+ Explorer member benefits, including 2 Stay Plus complimentary nights, will be valid per Card Year. None of the member benefits will be retroactively accrued.</p>
                       
                        <p>- *Standard terms and conditions governing the use of an ALL Accor+ Explorer Explorer membership apply. Please view the ALL Accor+ Explorer membership <a href="https://www.accorplus.com/sg/about/terms-and-conditions/">terms and conditions</a> for more details. T&C’s apply and subject to changes without prior notice.</p>    
                       
                        <p>- Stay or dining exceptions may apply to the standard ALL Accor+ Explorer member benefits, please refer to the <a href="https://www.accorplus.com/sg/about/terms-and-conditions/">member benefits exception list</a> for more details.</p>

                        <p>- For any enquiries on ALL Accor+ Explorer membership, please contact the ALL Accor+ Explorer Member Services team via the <a href="https://accorplushelp.zendesk.com/hc/en-au" target="_blank" rel="noreferrer">Member Help Centre</a>.</p>    
                    </div>
                </div>
            </div>
        );
    }
}

export default (Home);
